import React from 'react';

const DocumentIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6522 3.34766V14.3042C14.6522 16.8868 12.6044 18.9998 10.1015 18.9998H3.27539V5.34766C3.27539 4.24309 4.17082 3.34766 5.27539 3.34766H14.6522Z"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path d="M6.30908 8.04331H11.6183" stroke="#555B67" strokeWidth="2" />
    <path d="M6.30908 11.1742H11.6183" stroke="#555B67" strokeWidth="2" />
    <path d="M6.30908 14.3045H10.291" stroke="#555B67" strokeWidth="2" />
    <path
      d="M12.3768 3.34783V1H3C1.89543 1 1 1.89543 1 3V16.6522H3.27536"
      stroke="#555B67"
      strokeWidth="2"
    />
  </svg>
);

export default DocumentIcon;
